"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _useRecommendationActions = require("../../hooks/recommendation/useRecommendationActions");
var _useRecommendationHandsets = require("../../hooks/recommendation/useRecommendationHandsets");
var _useRecommendationPlans = require("../../hooks/recommendation/useRecommendationPlans");
var _useComparisonSetup = _interopRequireDefault(require("../../hooks/comparison/useComparisonSetup"));
var _useRecommendationStepper = require("../../hooks/recommendation/useRecommendationStepper");
var _useUpsellProducts2 = require("../../hooks/upsell/useUpsellProducts");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _shareRecommendationActions = require("../../store/shareRecommendation/shareRecommendationActions");
var _ShareRecommendation = _interopRequireDefault(require("../ShareRecommendation"));
var _useRecommendationBroadbands = require("../../hooks/recommendation/useRecommendationBroadbands");
var _useRecommendationBusinessSolutions = require("../../hooks/recommendation/useRecommendationBusinessSolutions");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var RecommendationFooterWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n"])));
var RecommendationFooterWrapperItem = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  ", "\n"])), _r10SourceLibrary.Mixins.respondTo.md("max-width: 50%; min-width: 50%; margin: auto;"));
var ShareButtonWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"])));
var RecommendationFooter = function RecommendationFooter() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useRecommendationAct = (0, _useRecommendationActions.useRecommendationActions)(),
    isCheckoutInProgress = _useRecommendationAct.isCheckoutInProgress,
    compareProducts = _useRecommendationAct.compareProducts;
  var _useRecommendationHan = (0, _useRecommendationHandsets.useRecommendationHandsets)(),
    selectedHandset = _useRecommendationHan.selectedHandset;
  var _useRecommendationPla = (0, _useRecommendationPlans.useRecommendationPlans)(),
    selectedPlan = _useRecommendationPla.selectedPlan;
  var _useRecommendationBro = (0, _useRecommendationBroadbands.useRecommendationBroadbands)(),
    selectedBroadband = _useRecommendationBro.selectedBroadband;
  var _useRecommendationBus = (0, _useRecommendationBusinessSolutions.useRecommendationBusinessSolutions)(),
    selectedBusinessSolution = _useRecommendationBus.selectedBusinessSolution;
  var _useUpsellProducts = (0, _useUpsellProducts2.useUpsellProducts)(),
    selectedUpsellProducts = _useUpsellProducts.selectedUpsellProducts;
  var _useRecommendationSte = (0, _useRecommendationStepper.useRecommendationStepper)(),
    onNextStepper = _useRecommendationSte.onNextStepper,
    isLastStep = _useRecommendationSte.isLastStep,
    currentStepObject = _useRecommendationSte.currentStepObject;
  (0, _useComparisonSetup.default)(currentStepObject.stepType);
  var showShareButton = (0, _reactRedux.useSelector)(_widgetSelectors.selectConfigShareRecommendation);
  var isAirtimePlanStep = currentStepObject.stepType === 'AIRTIME_PLAN';
  var isHandsetStep = currentStepObject.stepType === 'HANDSET';
  var comparisonButtonText = isHandsetStep ? 'Recommendation.compareDevices' : isAirtimePlanStep ? 'Recommendation.comparePlans' : 'Recommendation.compareBroadbands';
  var nextButtonText = isAirtimePlanStep ? 'Questionnaire.ButtonChoosePlan' : 'Questionnaire.ButtonNext';
  var handleNext = function handleNext() {
    !isLastStep && onNextStepper();
    currentStepObject === null || currentStepObject === void 0 ? void 0 : currentStepObject.onNext({
      selectedHandset: selectedHandset,
      selectedPlan: selectedPlan,
      selectedBroadband: selectedBroadband,
      selectedUpsellProducts: selectedUpsellProducts,
      selectedBusinessSolution: selectedBusinessSolution
    });
  };
  var RenderComparisonButton = function RenderComparisonButton() {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      width: "full",
      state: isCheckoutInProgress ? 'disabled' : '',
      text: _services.locale.localeString(comparisonButtonText),
      onClick: function onClick() {
        compareProducts();
      },
      appearance: "secondary"
    });
  };
  var RenderNextButton = function RenderNextButton() {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      width: "full",
      state: isCheckoutInProgress ? 'disabled' : '',
      text: _services.locale.localeString(nextButtonText),
      onClick: handleNext
    });
  };
  return /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapper, null, /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapperItem, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4
    }
  }, /*#__PURE__*/_react.default.createElement(RenderNextButton, null))), currentStepObject.showComparisonButton && /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapperItem, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4
    }
  }, /*#__PURE__*/_react.default.createElement(RenderComparisonButton, null))), isLastStep && showShareButton && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(RecommendationFooterWrapperItem, null, /*#__PURE__*/_react.default.createElement(ShareButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
    appearance: "primary",
    text: _services.locale.localeString('ShareRecommendation.ButtonText'),
    icon: {
      name: 'share',
      justify: 'left',
      group: 'system',
      appearance: 'secondary'
    },
    onClick: function onClick() {
      return dispatch((0, _shareRecommendationActions.showShareRecommendation)());
    }
  })))), /*#__PURE__*/_react.default.createElement(_ShareRecommendation.default, null)));
};
var _default = RecommendationFooter;
exports.default = _default;